import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Base } from '@stepstone-genesis/components';
import DOMPurify from 'dompurify';
import { brandLogoSelector } from '../../../core/siteConfig/siteConfigSlice.js';
import { useAppSelector } from '../../../hooks/redux/index.js';
export const BrandLogo = () => {
    const brandLogo = useAppSelector(brandLogoSelector) || '';
    const sanitizedBrandLogo = DOMPurify.sanitize(brandLogo);
    return (_jsx(Base, { sx: {
            justifyContent: 'flex-start',
            position: ['absolute', 'relative'],
            pl: ['spaceNone', 'spaceXxs'],
        }, children: _jsx(Base, { sx: {
                height: 'size30',
                '& svg': {
                    height: '100%',
                    width: 'auto',
                    display: 'block',
                },
            }, dangerouslySetInnerHTML: { __html: sanitizedBrandLogo } }) }));
};
//# sourceMappingURL=BrandLogo.js.map